import { css } from '@emotion/react';
import * as React from 'react';

interface OwnProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tappableAreaSize: string;
}

export const IconButton: React.FC<OwnProps> = ({ tappableAreaSize, children, ...buttonProps }) => {
  return (
    <div css={styles.wrapperStyle}>
      <button css={styles.buttonStyle} {...buttonProps}>
        {children}
        <div className="tapableArea" css={styles.tappableArea(tappableAreaSize)} />
      </button>
    </div>
  );
};

const styles = {
  wrapperStyle: css({
    '.focus-visible .tapableArea': {
      border: '2px dotted black',
      outline: 0,
    },
  }),
  buttonStyle: css({
    position: 'relative',
    padding: '0px',
    borderStyle: 'none',
    background: 'none',
    ':focus': {
      outline: 0,
    },
  }),
  tappableArea: (size: string) =>
    css({
      cursor: 'pointer',
      position: 'absolute',
      width: `calc(100% + ${size})`,
      height: `calc(100% + ${size})`,
      top: `calc(-${size}/2)`,
      left: `calc(-${size}/2)`,
    }),
};
